<template>
  <div>
    <div :class="{
        'layout-header': true,
        header1: $route.meta.header1,
        header2: $route.meta.header2,
        header3: $route.meta.header3,
        header4: $route.meta.header4,
        header5: $route.meta.header5,
        header7: $route.name == 'home'&&home_active == 2,
      }">
      <!-- header1 17.5rem的顶部 -->
      <div class="head_inner" v-if="($route.meta.header1) || $route.meta.header4">
        <div class="inner_top">
          <p class="title" v-if="!$route.meta.market">
            <van-icon class="back_icon" name="arrow-left" v-if="$route.name == 'sell'" @click="$router.go(-1)"/>
            {{ headerTitle }}
          </p>
          <div class="market" :class="{'bothclass': prop_trade == 1 && role_trade == 1}" v-else @click="closePop">
            <span :class="{'active': home_active == 1}" @click.prevent="changeHome(1)" v-if="prop_trade == 1">道具市场</span>
            <span :class="{'active': home_active == 2}" @click.prevent="changeHome(2)" v-if="role_trade == 1">角色市场</span>

            <p v-if="prop_trade == 0&&role_trade == 0">市场</p>
          </div>
          <div class="search_choose" @click="closePop">
            <div class="search" v-if="home_active != 2">
              <van-search readonly placeholder="搜索装备名称" @click.stop="gotosearch" v-if="$route.name != 'search'">
                <template #left-icon>
                    <img class="search_left_icon" src="../../assets/version_1.3.0/index/search_icon.png" alt="">
                </template>
              </van-search>
              <van-search v-model="keywords" autofocus placeholder="搜索装备名称" @search="search" v-else ref="search">
                <template #left-icon>
                    <img class="search_left_icon" src="../../assets/version_1.3.0/index/search_icon.png" alt="">
                </template>
              </van-search>
            </div>
            <div class="search" v-else>
              <van-search placeholder="请输入商品名称" v-model="goods_key" @search="searchGoods">
                <template #left-icon>
                    <img class="search_left_icon" src="../../assets/version_1.3.0/index/search_icon.png" alt="">
                </template>
              </van-search>
            </div>
            <!-- <div class="choose" @click.prevent="openGamePop">
              <img class="game_icon" :src="gameIcon" alt=""  v-if="gameIcon"/>
              <div class="game_icon" v-else></div>
              <div class="game_name">
                {{ gameName == "" ? "游戏列表" : gameName }}
              </div>
            </div> -->
          </div>

          <!-- 出售 -->
          <div v-if="$route.name == 'sell'" class="user_select">
            <div :class="{ 'sort_btn': true,'mybag':true, active: cPack == 'pack' }" @click="changePack('pack')">
              <div class="icon"></div>
              我的账号
            </div>
            <div :class="{ 'sort_btn': true,'onsell':true, active: cPack == 'ing' }" @click="changePack('ing')">
              <div class="icon"></div>
              正在出售
            </div>
            <!-- 有角色 -->
            <div style="max-width: 15rem !important" class="role hasrole1" @click.stop="changeRole" v-if="role_id != ''">
              <span class="choose_roleinfo">{{ server_name }} {{ role_name }}</span>
            </div>
          </div>

          <div class="user_select" v-if="$route.name == 'home'&& home_active != 2" style="padding-right: 4rem;">
            <div :class="{'sort_btn':true,'sort_btn2':true, 'role_hot': true, active: sort == 'hot' }" @click="changeSort('hot')">
              <div class="icon"></div>
              热门物品
            </div>
            <div :class="{ 'sort_btn':true,'sort_btn2':true,'role_new': true, active: sort == 'new' }" @click="changeSort('new')">
              <div class="icon"></div>
              最新上架
            </div>
            <!-- 有选择区服 -->
            <div class="sort_btn active sort_btn2 ellipsis hasrole" @click.stop="openServer" v-if="home_server_id != ''">
              <span class="choose_roleinfo">{{ home_server_name }}</span>
            </div>
            <div class="sort_btn active sort_btn2 ellipsis" @click="openServer" v-else>选择区服</div>

            <img class="sx" src="../../assets/bx/sx.png" alt="" @click="openFilter" />
          </div>
          <div class="user_select user_select2" v-else-if="$route.name == 'home'&&home_active == 2">
            <div :class="['sort_btn',{ 'role_hot': true, active: role_sort == 'role_hot' }]"  @click="changeRoleSort('role_hot')">
              <div class="icon"></div>
              热门角色
            </div>
            <div :class="['sort_btn',{ 'role_new': true, active: role_sort == 'role_new' }]" @click="changeRoleSort('role_new')">
              <div class="icon"></div>
              最新上架
            </div>
            <div :class="['sort_btn',{'role_price': true, active: role_price == 'asc'||role_price == 'desc' }]" @click="changePriceSort">
              <div class="icon"></div>
              {{role_price =='' ? '价格排序': (role_price == 'asc'?'价格升序':'价格降序')}}
            </div>
          </div>
        </div>
        <div class="inner_bottom" v-if="$route.name != 'search'" @click="closePop">
          <p>平台保证，安心无忧</p>
          <div class="bottom_radius" :class="{'white':($route.name == 'home'&&home_active == 2)&&(showplat||showqf||showprice)}"></div>
        </div>
        <div class="inner_bottom2" v-else>
          <div class="bottom_radius">
            <img class="filter_icon" src="../../assets/bx/filter_icon.jpg" alt="" @click="openFilter2">
            <div class="back_close" @click="back"></div>
          </div>
        </div>

        <div v-if="$route.name == 'home'&&home_active == 2" class="sx_area" :class="{'active':showplat||showqf||showprice}">
          <div class="sx_item plat" @click="openplat">
            {{ ac_plat == '' ? '全部平台' : (ac_plat == 1?'安卓':(ac_plat == 2?'IOS':(ac_plat == 3? '安卓/ios互通':''))) }}
          </div>
          <div class="sx_item qf" @click="openqf">
            {{ac_server_name == '' ? '综合区服' : ac_server_name }}
          </div>
          <div class="sx_item jg" @click="openjg">
            {{ac_price_sx == ''?'全部价格':((min_price!=''&&max_price!='')?(min_price + '-' + max_price):((min_price!=''&&max_price == ''?min_price + '以上':'全部价格')))}}
          </div>
          <div class="box" :class="{'plat_box':showplat}">
            <ul class="plats">
              <li :class="{'active': ac_plat == ''}" @click="changePlat('')">全部平台</li>
              <li :class="{'active': ac_plat == 1}" @click="changePlat(1)">安卓</li>
              <li :class="{'active': ac_plat == 2}" @click="changePlat(2)">IOS</li>
              <li :class="{'active': ac_plat == 3}" @click="changePlat(3)">安卓/ios互通</li>
            </ul>
          </div>
          <div class="box" :class="{'qf_box': showqf}">
            <div class="search" v-if="showqf">
                <van-search show-action v-model="serverKey" placeholder="请输入您的区服" @search="onSearch">
                  <template #action>
                    <div class="action" @click="onSearch">搜索</div>
                  </template>
                </van-search>
                <div class="scroll_area" style="overflow-y: auto;height: 32.6rem;">
                  <notice-scroll :url="'game/app-server-list'" :params="{app_id:this.gameId,keyword: this.keyServer}" :method="'get'" :text="''">
                    <template slot-scope="scope">
                      <div class="server_list">
                        <div class="server_item"
                          :class="{'active': ac_server_id == item.server_id}"
                          v-for="(item,i) in scope.data" :key="i" @click="chooseServer(item.server_id,item.server_name)">
                          {{ item.server_name }}
                        </div>
                      </div>
                    </template>
                  </notice-scroll>
                </div>
              </div>
          </div>
          <!-- 价格筛选 -->
          <div class="box" :class="{'jg_box': showprice}">
            <div class="price">
              <div class="title">价格区间（元）</div>
              <div class="rang" :class="{'active': jg_index == 1}" @click="chooseJg(1)">
                <van-field type="number" placeholder="最低价格范围" v-model="self_min"></van-field>
                <div class="line"></div>
                <van-field type="number" placeholder="最高价格范围" v-model="self_max"></van-field>
              </div>
              <div class="choose_rang">
                <div class="rang_item" :class="{'active': jg_index == 2}"  @click="chooseJg(2)">100-500</div>
                <div class="rang_item" :class="{'active': jg_index == 3}"  @click="chooseJg(3)">500-1000</div>
                <div class="rang_item" :class="{'active': jg_index == 4}"  @click="chooseJg(4)">1000-5000</div>
                <div class="rang_item" :class="{'active': jg_index == 5}"  @click="chooseJg(5)">5000-1万</div>
                <div class="rang_item" :class="{'active': jg_index == 6}"  @click="chooseJg(6)">1万以上</div>
              </div>
              <div class="btns">
                <van-button class="btn reset" @click="reset">重置</van-button>
                <van-button class="btn confirm" @click="confirm">确定</van-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="common_header" v-else-if="$route.meta.header2">
        <van-icon name="arrow-left" class="back_icon" @click="back2" />
        <span class="lh_title" v-if="headerTitle">{{ headerTitle }}</span>
      </div>
      <!-- 13rem的顶部 个人中心-->
      <div class="head_inner" v-else-if="$route.meta.header3">
        <div class="inner_top">
          <p class="title">
            {{ headerTitle }}
          </p>
          <div class="user_info">
            <div class="user">
              <img class="icon" src="../../assets/bx/avatar.png" alt="" />
              <div class="un_login" @click="$router.push({ name: 'user.login' })" v-if="!isLogin">
                立即登录
                <img class="sj" src="../../assets/bx/right_sj.png" alt="" />
              </div>
              <div class="login" v-else>
                {{ userData.username || "" }}
              </div>
            </div>
            <div class="wallet">
              <span class="prefix">我的钱包：</span>
              <span class="wallet_num"><i>&yen;</i>{{ userData.balance }}</span>
              <span class="goto_wallet" @click="gotoWallet">详情</span>
            </div>
          </div>
        </div>
        <div class="inner_bottom">
          <div class="bottom_radius"></div>
        </div>
      </div>
      <!-- 内页的顶部 -->
      <div class="head_inner" v-else>
        <div class="inner_top">
          <p class="title">
            {{ headerTitle }}
          </p>
        </div>
        <div class="inner_bottom">
          <div class="bottom_radius">
            <div class="back_close" @click="back"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg1" v-if="showplat || showqf || showprice" @click="showplat = false;showqf = false;showprice = false"></div>
  </div>
</template>

<script>
import $ from 'jquery'
  export default {
    name: "layout-header",
    data() {
      return {
        // 搜索
        keywords: "",

        showplat: false,//客户端选择
        showqf: false,//区服选择
        showprice: false,
        serverKey: '',//区服搜索
        keyServer: '',//区服搜索 关键字
        jg_index: 0,
        self_min: '',
        self_max: '',
        goods_key: ''
      };
    },
    computed: {
      headerTitle() {
        const override = this.$store.state.pageTitleOverride
        if (override && override.routeName && override.routeName === this.$route.name) {
          return override.title || ''
        }
        return (this.$route && this.$route.meta && this.$route.meta.title) ? this.$route.meta.title : ''
      },
      role_id() {
        return this.$store.state.role_id
      },
      role_name() {
        return this.$store.state.role_name
      },
      server_id() {
        return this.$store.state.server_id
      },
      server_name() {
        return this.$store.state.server_name
      },
      home_server_id() {
        return this.$store.state.home_server_id
      },
      home_server_name() {
        return this.$store.state.home_server_name
      },
      gameList() {
        return this.$store.state.gameList || null;
      },
      gameName() {
        return this.$store.state.gameName;
      },
      gameIcon() {
        return this.$store.state.gameIcon;
      },
      gameId() {
        return this.$store.state.gameId;
      },
      userData() {
        return this.$store.getters.state.userData || {};
      },
      isLogin() {
        return this.$store.getters.isLogin;
      },
      // 热门还是最新
      sort() {
        return this.$store.state.sort;
      },
      // 背包还是出售
      cPack() {
        return this.$store.state.cPack
      },
      prop_trade() {
        return this.$store.state.prop_trade
      },
      role_trade() {
        return this.$store.state.role_trade
      },
      //道具or角色 市场
      home_active() {
        return this.$store.state.home_active
      },
      //角色市场 hot or new
      role_sort() {
        return this.$store.state.role_sort
      },
      //角色市场 价格  升序asc 降序 desc
      role_price() {
        return this.$store.state.role_price
      },
      //价格筛选 index
      ac_price_sx() {
        return this.$store.state.ac_price_sx
      },
      min_price() {
        return this.$store.state.min_price
      },
      max_price() {
        return this.$store.state.max_price
      },
      ac_server_id() {
        return this.$store.state.ac_server_id
      },
      ac_server_name() {
        return this.$store.state.ac_server_name
      },
      ac_plat() {
        return this.$store.state.ac_plat
      },
      goods_name() {
        return this.$store.state.goods_name
      }
    },
    created() {
      if(this.$route.name == 'home') {
        if(this.$route.query&&this.$route.query.id) {
          this.$Ajax('game/app-list').then(rs => {
            if (rs.code == 200) {
              rs.data.forEach(item => {
                if(item.id == this.$route.query.id) {
                  this.chooseGame(item.app_name,item.icon,item.id,item.prop_trade,item.role_trade)
                }
              });
            }
          })
        }
      }
    },
    mounted() {
      var that = this;
      
    },
    updated() {
      if(this.$route.name == 'search') {
        if(this.keywords == '') {
          $('.van-search input').focus()
        }
      }
    },
    methods: {
      searchGoods() {
        this.$store.commit('setGoodsname',this.goods_key)
      },
      // 打开选择平台
      openplat() {
        this.showqf = this.showprice = false
        this.showplat = !this.showplat
      },
      //切换平台
      changePlat(i) {
        this.$store.commit('setPlat',i)
        this.showplat = !this.showplat
      },
      //打开选择区服
      openqf() {
        this.showplat = this.showprice = false
        this.showqf = !this.showqf
      },
      //区服搜索
      onSearch() {
        this.keyServer = this.serverKey
      },
      chooseServer(server_id,server_name) {      
        this.showplat = this.showprice = this.showqf = false
        this.$store.commit('setAcServer',{ac_server_id: server_id,ac_server_name: server_name})
      },
      //打开选择价格
      openjg() {
        this.showplat = this.showqf = false
        this.jg_index = this.ac_price_sx
        if(this.jg_index == 1) {
          this.self_min = this.min_price
          this.self_max = this.max_price
        }
        this.showprice = !this.showprice
      },
      chooseJg(index) {
        this.jg_index = index
      },
      reset() {
        this.jg_index = 0
        this.self_min = ''
        this.self_max = ''
        this.$store.commit('setPrice',{ac_price_sx: 0,min_price: '',max_price: ''})
      },
      confirm() {
        if(this.jg_index == 1) {
          if((Number(this.self_min) < 0 || Number(this.self_max) < 0) || (Number(this.self_max) <= Number(this.self_min)) || this.self_min == '' || this.self_max == '') {
            this.$toast('请输入正确的价格区间')
            return
          }
          this.$store.commit('setPrice',{ac_price_sx: 1,min_price: this.self_min,max_price: this.self_max})
        }else if(this.jg_index == 2) {
          this.$store.commit('setPrice',{ac_price_sx: 2,min_price: 100,max_price: 500})
        }else if(this.jg_index == 3) {
          this.$store.commit('setPrice',{ac_price_sx: 3,min_price: 500,max_price: 1000})
        }else if(this.jg_index == 4) {
          this.$store.commit('setPrice',{ac_price_sx: 4,min_price: 1000,max_price: 5000})
        }else if(this.jg_index == 5) {
          this.$store.commit('setPrice',{ac_price_sx: 5,min_price: 5000,max_price: 10000})
        }else if(this.jg_index == 6) {
          this.$store.commit('setPrice',{ac_price_sx: 6,min_price: 10000,max_price: ''})
        }
        this.showprice = false
      },


      back2() {
        if((this.$route.name == 'user.order' || this.$route.name == 'goods.detail')&&this.$route.query.is_pay) {
          this.$router.push({name: 'user.buy',params: {status: 0}})
          return
        }
        if(this.$route.name == 'user.buy' || this.$route.name == 'user.sell') {
          this.$router.push({
            name: 'user.center'
          })
          return
        }
        if(this.$route.name == 'user.wallet') {
          this.$router.push({
            name: 'user.center'
          })
          return
        }
        if(this.$route.name == 'user.withdraw') {
          this.$router.push({
            name: 'user.wallet'
          })
          return
        }
        if(this.$route.name == 'user.recharge' || this.$route.name == 'margin.recharge') {
          if(this.$route.query.from == 'accbuy') {
            this.$router.go(-1);
          }else {
            this.$router.push({
              name: 'user.wallet'
            })
          }
          return
        }

        if(this.$route.name == 'order.detail'&&this.$route.query.from == 'puton'){
          this.$router.push({
            name: 'sell'
          })
        }else {
          if (window.history.state && window.history.state.noBackFromEntry) {
            this.$router.push({ path: '/' })
          } else if (window.history.length > 1) {
            this.$router.go(-1)
          } else {
            this.$router.push({ path: '/' })
          }
        } 
      },
      back() {
        if((this.$route.name == 'goods.detail')&&this.$route.query.is_pay) {
          this.$router.push({name: 'user.buy',params: {status: 0}})
          return
        }
        if(this.$route.name == 'user.identity') {
          let redirect = sessionStorage.getItem('identity_redirect');
          if (redirect) {
            sessionStorage.removeItem('identity_redirect');
            this.$router.push(redirect);
          } else {
            this.$router.push({
              name: 'user.center'
            })
          }
          return
        }
        if(this.$route.name == 'user.wallet') {
          this.$router.push({
            name: 'user.center'
          })
          return
        }
        if(this.$route.name == 'user.withdraw') {
          this.$router.push({
            name: 'user.wallet'
          })
          return
        }
        if(this.$route.name == 'user.recharge' || this.$route.name == 'margin.recharge') {
          if(this.$route.query.from == 'accbuy') {
            this.$router.go(-1);
          }else {
            this.$router.push({
              name: 'user.wallet'
            })
          }
          return
        }
        this.$router.go(-1);
      },
      gotosearch() {
        if(this.gameId == '' || this.gameId == undefined) {
          this.$filterPop({
            type: 'game'
          })
          return
        }
        // if(this.$store.state.role_id == '' || this.$store.state.role_id == undefined) {
        //   this.$RModal.bindtips()
        //   return
        // }
        if(this.$store.state.home_server_id == '' || this.$store.state.home_server_id == undefined) {
          this.$filterPop({
            type: 'server',
            direction: 'up'
          })
          return
        }
        this.keywords = ''
        this.$store.commit("changekeywords", '');
        this.$router.push({
          name: 'search'
        })
      },
      search() {
        if (this.keywords.trim() != "") {
          this.$store.commit("changekeywords", this.keywords);
        }else {
          this.$store.commit("changekeywords", '');
        }
      },
      //选择 热门物品 最新上架
      changeSort(sort) {
        this.$store.commit('changSort', sort)
      },
      // 选择我的背包,正在出售
      changePack(cPack) {
        this.$store.commit('setPack', cPack)
      },
      //打开选择游戏
      openGamePop() {
        this.$filterPop({
          type: "game",
        });
      },
      //打开选择角色
      // openRole() {
      //   this.$Ajax('user-info/check-bind-account', {
      //     app_id: this.gameId
      //   }).then(rs => {
      //     if (rs.code == 200) {
      //       if(rs.data.is_bind) {
      //         this.$filterPop({
      //           type: "role",
      //         });
      //       }else {
      //         this.$RModal.bindtips()
      //       }
      //     } else {
      //       this.$RModal.bindtips()
      //       this.isbind = false
      //     }
      //   })

      // },
      //筛选条件
      openFilter() {
        if(this.gameId == '' || this.gameId == undefined) {
          this.$filterPop({
            type: 'game'
          })
          return
        }
        this.$filterPop({
          type: "props",
        });
      },
      //搜索筛选条件
      openFilter2() {
        this.$filterPop({
          type: "props2",
        });
      },
      //检查用户是否绑定账号
      checkBindAccount(app_id) {
        this.$Ajax('user-info/check-bind-account', {
          app_id
        }).then(rs => {
          if (rs.code == 200) {
            this.isbind = rs.data.is_bind
          } else {
            this.isbind = false
          }
        })
      },
      
      //前往绑定角色
      bindRole() {
        if(this.gameId == '' || this.gameId == undefined) {
          this.$filterPop({
            type: 'game'
          })
          return
        }
        this.$router.push({
          name: 'user.bind'
        })
      },
      //打开选择区服
      openServer() {
        this.$filterPop({
          type: 'server',
          direction: 'up'
        })
      },
      changeRole() {
        this.$store.commit('resetinfo',{
          role_id: '',
          role_name: '',
        })
      },
      gotoWallet() {
        if(this.isLogin) {
          this.$router.push({name: 'user.wallet'})
        }else {
          this.$filterPop({
            type: 'login',
            direction: 'up',
            onSuccess: () => {
              this.$router.push({name: 'user.wallet'})
            }
          })
        }
      },
      closePop() {
        this.showplat=this.showqf=this.showprice=false
      },
      //切换市场
      changeHome(active) {
        if(active != this.home_active) this.$store.commit('changeHome',active)
      },
      //角色市场  切换热门or最新上架
      changeRoleSort(sort) {
        this.$store.commit('changeRoleSort',sort)
      },
      //角色市场  切换价格排序
      changePriceSort() {
        if(this.role_price == 'desc' || this.role_price == '') {
          this.$store.commit('changeRolePrice','asc')
        }else {
          this.$store.commit('changeRolePrice','desc')
        }
      },
      chooseGame(name, icon, id,prop_trade,role_trade) {
        this.$store.commit('resetServer')
        this.$store.commit('resetHomeServer')
        this.$store.commit('setGameInfo', {
            name,
            icon,
            id
        })
                
        this.$store.commit('setCt','')
        this.$store.commit('setCi','')
        this.$store.commit('setCt2','')
        this.$store.commit('setCi2','')
        //道具市场 角色市场判断
        this.$store.commit('setHome',{prop_trade,role_trade})
        if(prop_trade == 0) {
          this.$store.commit('changeHome',2)
        }else {
          this.$store.commit('changeHome',1)
        }
        //角色市场 筛选全部重置
        this.$store.commit('resetAccPx')    
      },
    },
    watch: {
      home_active: {
        immediate: true,
        handler(e) {
          this.showplat = this.showprice = this.showqf = false
        }
      },
      goods_name: {
        immediate: true,
        handler(e) {
          if(e != '') {
            this.goods_key = e
          }
        }
      },
      // gameId: {
      //   immediate: true,
      //   handler(e) {
      //     this.checkBindAccount(e)
      //   }
      // },
    },
  };
</script>

<style lang="less" scoped>
  .layout-header {
    position: fixed;
    top: 0;
    left: 50%;
    width: 102%;
    max-width: 525px;
    transform: translateX(-50%);
    text-align: center;
    font-size: 1.7rem;
    z-index: 100;
    height: 7.4rem;

    .head_inner {
      height: 100%;

      .inner_top {
        position: abslute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
        background-color: #fff;

        .title {
          font-size: 1.8rem;
          margin: 1.3rem auto;
          display: inline-block;
          color: #fff;
        }
      }

      .inner_bottom,
      .inner_bottom2 {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;

        .bottom_radius {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 1.2rem;
          border-top-left-radius: 2rem;
          border-top-right-radius: 2rem;
          background-color: var(--innerbgc);
          transform: translateY(0.4rem);

          .back_close {
            position: absolute;
            bottom: -1.8rem;
            right: 1.2rem;
            width: 1.8rem;
            height: 1.8rem;
            cursor: pointer;

            &::before,
            &::after {
              content: "";
              position: absolute;
              top: 50%;
              left: 50%;
              width: 0.2rem;
              height: 2.4rem;
              background-color: var(--theme);
            }

            &::before {
              transform: translate(-50%, -50%) rotate(45deg);
            }

            &::after {
              transform: translate(-50%, -50%) rotate(-45deg);
            }
          }
          .filter_icon {
            position: absolute;
            bottom: -2.3rem;
            right: 5rem;
            width: 2rem;
            height: 2.4rem;
          }
        }
      }
    }
    &.header1 {
      .bottom_radius {
        background-color: #fbfbfb !important;
      }
    }
    &.header1,
    &.header4 {
      height: 17.5rem;

      .head_inner {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;

        .inner_top {
          height: 15rem;
          //background: linear-gradient(to bottom, var(--fade), var(--fade20));
          background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
          background-color: #fff;
          .search_choose {
            height: 3.5rem;
            display: flex;
            justify-content: space-between;
            padding-left: 1.2rem;
            padding-right: 1.2rem;
            margin-bottom: 1.5rem;

            .search {
              height: 100%;
              // width: 26rem;
              width: 100%;
              .van-search {
                padding: 0;
                height: 100%;
                border-radius: 10rem;
                overflow: hidden;

                .van-search__content {
                  background-color: transparent;
                }

                /deep/.van-field__left-icon {
                  margin-right: 1.2rem;

                  .van-icon-search {
                    color: var(--theme120);
                    font-size: 2.3rem;
                  }
                }

                /deep/.van-field__body {
                  .van-field__control {
                    font-size: 1.4rem;

                    &::placeholder {
                      color: var(--placeholder);
                    }
                  }
                }
              }
            }

            .choose {
              width: 9.5rem;
              height: 100%;
              background-color: rgba(255, 255, 255,0.79);
              border-top-left-radius: 10rem;
              border-bottom-left-radius: 10rem;
              display: flex;
              align-items: center;
              cursor: pointer;

              .game_icon {
                width: 3.5rem;
                height: 3.5rem;
                border-radius: 50%;
                background-color: #f2f2f2;
              }

              .game_name {
                flex: 1;
                font-size: 1.2rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                text-align: start;
                padding: 0 0.2rem;
              }
            }
          }

          .user_select {
            display: flex;
            align-items: center;
            padding-left: 1.2rem;
            position: relative;

            .hot,
            .new,
            .role,
            .hot1,
            .new1 {
              width: 9.4rem;
              height: 2.2rem;
              line-height: 2.3rem;
              color: #fff;
              font-size: 1.2rem;
              padding-left: 2.2rem;
              margin-right: 8px;
              cursor: pointer;
            }

            .hot {
              background: url(../../assets/bx/hot1.png) no-repeat 0 0 / 100% 100%;

              &.active {
                background: url(../../assets/bx/hot2.png) no-repeat 0 0 / 100% 100%;
              }
            }

            .hot1 {
              background: url(../../assets/bx/sell/warp1.png) no-repeat 0 0 / 100% 100%;

              &.active {
                background: url(../../assets/bx/sell/warp2.png) no-repeat 0 0 / 100% 100%;
              }
            }

            .new {
              padding-left: 2rem;
              background: url(../../assets/bx/new1.png) no-repeat 0 0 / 100% 100%;

              &.active {
                background: url(../../assets/bx/new2.png) no-repeat 0 0 / 100% 100%;
              }
            }

            .new1 {
              padding-left: 2rem;
              background: url(../../assets/bx/sell/sell1.png) no-repeat 0 0 / 100% 100%;

              &.active {
                background: url(../../assets/bx/sell/sell2.png) no-repeat 0 0 / 100% 100%;
              }
            }

            .role {
              background: url(../../assets/bx/role1.png) no-repeat 0 0 / 100% 100%;
              position: relative;

              &:hover {
                background: url(../../assets/bx/role2.png) no-repeat 0 0 / 100% 100%;
              }

              &.hasrole {
                width: 11.7rem;
                background: url(../../assets/bx/cr_bg.png) no-repeat 0 0 / 100% 100%;
                padding-left: 0;

                .choose_roleinfo {
                  display: block;
                  width: 100%;
                  padding: 0 1rem;
                  text-align: start;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }

              &.hasrole1 {
                width: 11.7rem;
                background: url(../../assets/bx/sell/list.png) no-repeat 0 0 / 100% 100%;
                padding-left: 0;

                .choose_roleinfo {
                  display: block;
                  width: 91%;
                  padding: 0 1rem;
                  text-align: start;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }

              .role_choose_pop {
                position: absolute;
                left: 0;
                top: 2.3rem;
                background-color: #fff;
                width: 11.7rem;
                max-height: 24rem;
                overflow-y: auto;
                z-index: 1000;
                border-radius: .9rem;
                padding: .7rem .5rem;

                li {
                  background-color: #f2f2f2;
                  color: var(--base);
                  border-radius: 10rem;
                  margin-bottom: .8rem;
                  text-align: start;
                  padding: .15rem .8rem;
                  font-size: 1.2rem;
                  line-height: 2rem;
                  transform: scale(0.95);
                  border: 1px solid transparent;

                  &.active,
                  &:hover {
                    border-color: var(--theme);
                    background-color: var(--active);
                    color: var(--theme);
                  }

                  &:nth-last-child(1) {
                    margin-bottom: 0;
                  }
                }
              }
            }

            .sx {
              width: 1.65rem;
              height: 1.9rem;
              position: absolute;
              right: 1.2rem;
              top: 50%;
              transform: translateY(-50%);
              cursor: pointer;
            }
          }
        }

        .inner_bottom {
          height: 3.6rem;
          background-color: #fff0e9;
          border-top-left-radius: 1rem;
          border-top-right-radius: 1rem;
          overflow: hidden;

          p {
            text-align: center;
            font-size: 1.2rem;
            line-height: 2.9rem;
            color: var(--theme);
            // color: #fff;
            transform: scale(0.95);
          }
        }
      }
    }

    &.header2 {
      height: 5rem;
    }

    &.header3 {
      height: 13rem;
      background-image: url("../../assets/bx/my2.png");
      background-position: 100% 0;
      background-repeat: no-repeat;
      background-size: 50%;
      background-color: var(--theme50);

      .inner_top {
        background: unset;

        .title {
          .title {
            font-size: 1.8rem;
            margin: 1.3rem auto;
            display: inline-block;
          }
        }

        .user_info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 1.2rem;

          .user {
            display: flex;
            align-items: center;

            .icon {
              width: 3.45rem;
              height: 3.45rem;
              margin-right: 0.7rem;
            }

            .un_login,
            .login {
              display: flex;
              align-items: center;
              color: #fff;
              font-size: 1.5rem;
              margin-top: 0.2rem;

              .sj {
                width: 1.15rem;
                height: 1.3rem;
                margin-left: 0.6rem;
              }
            }
          }

          .wallet {
            color: #fff;
            font-size: 1.5rem;
            display: flex;
            align-items: center;
            
            .prefix {
              display: inline-block;
            }

            .wallet_num {
              color: #fff;
              font-weight: 700;

              i {
                font-size: 1.2rem;
                margin-right: 0.2rem;
              }
            }

            .goto_wallet {
              display: inline-block;
              border: 1px solid #fff;
              // background-color: var(--theme);
              color: #fff;
              width: 4.5rem;
              height: 2.2rem;
              line-height: 2.2rem;
              font-size: 1.2rem;
              text-align: center;
              border-radius: 0.4rem;
              margin-left: 0.5rem;
              cursor: pointer;

              &:active {
                opacity: 0.9;
              }
            }
          }
        }
      }
    }
    &.header4 {
      height: 12rem;
      .inner_top {
        height: 12rem !important;
      }
    }
    .common_header {
      height: 5rem;
      line-height: 5rem;
      background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
      background-color: #fff;
      // border-bottom: 1px solid #eee;
      position: relative;
      .back_icon,
      .lh_title {
        color: #fff;
      }
    }
    .common_header2 {
      height: 5rem;
      line-height: 5rem;
      background: linear-gradient( 180deg, #FE4B1E 0%, #FF636F 100%);
      border-bottom: 1px solid #eee;
      position: relative;
      .back_icon,
      .lh_title {
        color: #fff;
      }
    }

    .game_choose_btn {
      position: absolute;
      right: 1rem;
      top: 50%;
      transform: translateY(-50%);
      width: 6.25rem;
      height: 2.2rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 1rem;
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 5rem;
      cursor: pointer;

      .game_icon {
        width: 2.2rem;
        height: 2.2rem;
        border-radius: 50%;
        background-color: #ddd;
      }

      .words {
        color: #f1f1f1;
        font-size: 1.2rem;
        height: 100%;
        line-height: 2.2rem;
      }
    }
  }

  .back_icon {
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 2rem;
    cursor: pointer;
  }

  .chooseGamePop {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    max-width: 525px;
    // transform: translateX(-50%);
    background-color: #fff;
    z-index: 2000;
    display: flex;
    flex-direction: column;

    .title {
      font-size: 1.7rem;
      height: 5rem;
      line-height: 5rem;
      text-align: center;
      position: relative;
      border-bottom: 1px solid #dcdee6;

      .choosegame_back_icon {
        position: absolute;
        left: 2rem;
        top: 50%;
        transform: translateY(-50%);
        font-size: 1.8rem;
        cursor: pointer;
      }
    }

    .games_content {
      flex: 1;
      overflow-y: auto;
      padding: 1rem 1rem;
      display: flex;
      flex-wrap: wrap;

      .game_item {
        width: calc(100% / 3);
        max-height: 12rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 1rem 0;
        border-radius: 0.6rem;
        cursor: pointer;

        .game_icon {
          width: 6.6rem;
          height: 6.6rem;
          border-radius: 1.2rem;
          margin-bottom: 0.6rem;
        }

        .game_name {
          padding: 0 0.3rem;
          font-size: 1.2rem;
          text-align: center;
          height: 3.2rem;
        }

        &.active,
        &:hover {
          background-color: rgba(71, 172, 243, 0.2);
          color: #47acf3;
        }
      }
    }

    .qf_content {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 4rem;
      height: calc(var(--vh, 1vh) * 100 - 5rem);

      .box_area {
        display: flex;
        align-items: center;
        margin-bottom: 2rem;
        width: 250px;

        .label {
          font-size: 15px;
        }

        .el-select {
          width: 202px;
        }
      }
    }
  }

  @media screen and (min-width: 525px) {
    .chooseGamePop {
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .header7 {
    z-index: 102;
    .bottom_radius {
      background-color: #fbfbfb !important;
    }
  }
  .market {
    height: 5rem;
    font-size: 1.8rem;
    padding: 1.3rem 2rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #fff;
    span {
      flex: 1;
      font-size: 1.6rem;
      transform-origin: 0 center;
      cursor: pointer;
      &:nth-child(2) {
        margin-left: 1.4rem;
      }
      &.active {
        font-weight: 700;
      }
    }
    &.bothclass {
      span {
        flex: unset;
      }
    }
    p {
      text-align: center;
      width: 100%;
    }
  }

  .user_select {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 1rem;
    .sort_btn {
      margin-right: 1.2rem;
      width: 11rem;
      height: 2.8rem;
      line-height: 2.8rem;
      // border: .2rem solid #fff;
      background-color: #fff;
      border-radius: 10rem;
      font-size: 1.4rem;
      color: var(--theme);
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      cursor: pointer;
      &:nth-last-child(1) {
        margin-right: 0;
      }
      &.sort_btn2 {
        width: 10rem;
        text-align: center;
      }
      &.ellipsis {
        padding: 0 1rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
      }
      .icon {
        margin-right: 0.2rem;
        width: 2rem;
        height: 2rem;
        background-position: 0 0;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      &.role_hot {
        .icon {
          background-image: url(../../assets/version_1.3.0/market/icon1_a.png);
        }
      }
      &.role_new {
        .icon {
          background-image: url(../../assets/version_1.3.0/market/icon2_a.png);
        }
      }
      &.role_price {
        .icon {
          background-image: url(../../assets/version_1.3.0/market/icon3_a.png);
        }
      }
      &.mybag {
        .icon {
          background-image: url(../../assets/version_1.3.0/sell/bag_a.png);
        }
      }
      &.onsell {
        .icon {
          background-image: url(../../assets/version_1.3.0/sell/sell_a.png);
        }
      }
      &.active {
        background-color: var(--theme);
        color: #fff;
        &.role_hot {
        .icon {
            background-image: url(../../assets/version_1.3.0/market/icon1_b.png);
          }
        }
        &.role_new {
          .icon {
            background-image: url(../../assets/version_1.3.0/market/icon2_b.png);
          }
        }
        &.role_price {
          .icon {
            background-image: url(../../assets/version_1.3.0/market/icon3_b.png);
          }
        }
        &.mybag {
          .icon {
            background-image: url(../../assets/version_1.3.0/sell/bag_b.png);
          }
        }
        &.onsell {
          .icon {
            background-image: url(../../assets/version_1.3.0/sell/sell_b.png);
          }
        }
      }
    }
  }


  .sx_area  {
    display: flex;
    align-items: center;
    margin-top: 2.4rem;
    padding: .3rem 2rem .7rem 0;
    font-size: 1.4rem;
    background-color: #fbfbfb;
    position: relative;
    &.active {
      background-color: #fff;
    }
    .sx_item {
      color: #555;
      width: 9rem;
      height: 2rem;
      line-height: 2rem;
      margin-right: 1rem;
      padding-right: 1.6rem;
      text-align: end;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
      position: relative;
      &::after {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-30%);
        content: '';
        width: 0;
        height: 0;
        border-top: .5rem solid #555; 
        border-right: .5rem solid transparent;
        border-left: .5rem solid transparent;
        border-bottom: .5rem solid transparent;
        border-radius: 0.3rem;
      }
      &:hover {
        color: var(--theme);
        &::after {
          border-top: .5rem solid var(--theme); 
        }
      }
      &.plat {
        padding-left: 1rem;
      }
      // &.qf {
      //   width: 8.6rem;
      //   overflow: hidden;
      //   white-space: nowrap;
      //   text-overflow: ellipsis;
      // }
    }
    .box {
      position: absolute;
      width: 100%;
      left: 0;
      top: 2.9rem;
      background-color: #fff;
      transition: all ease .5s;
      -webkit-transition: all ease .5s;
      -o-transition: all ease .5s;
      -moz-transition: all ease .5s;
      height: 0;
      display: flex;
      overflow: hidden;
      border-bottom-left-radius: 1rem;
      border-bottom-right-radius: 1rem;
      &.plat_box {
        height: 13.5rem;
      }
      &.qf_box {
        height: 36rem;
      }
      &.jg_box {
        height: 24rem;
      }

      .plats {
        width: 100%;
        padding-top: .5rem;
        li {
          padding: .6rem 2rem;
          font-size: 1.4rem;
          width: 100%;
          text-align: left;
          &.active {
            color: var(--theme);
          }
        }
      }
      .search {
        width: 100%;
        padding-top: 1rem;
        .van-search {
          padding: 0 1rem;
          height: 3rem;
          .van-search__content {
            border-radius: 10rem;
            .van-field {
              height: 3.4rem;
              display: flex;
              align-items: center;
              padding: 0;
              padding-right: 1.5rem;
            }
            /deep/.van-field__left-icon {
              .van-icon {
                font-size: 1.6rem;
                // color: var(--theme);
              }
            }
            /deep/input {
              font-size: 1.4rem;
              color: #000;
            }
          }
          .action {
            color: var(--theme);
            font-size: 1.4rem;
          }
        }
      }
      .scroll_area {
        &::-webkit-scrollbar {
          width: 6px;
        }
        &::-webkit-scrollbar-thumb {
          width: 100%;
          border-radius: 2rem;
          -webkit-box-shadow: inset 0 0 8px #555;
        }
        &::-webkit-scrollbar-track {
          width: 100%;
          -webkit-box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.2);
          border-radius: 2rem;
        }
      }
      .server_list {
        padding: 1rem;
        display: flex;
        flex-wrap: wrap;
        overflow-y: auto;
        .server_item {
          width: 16.6rem;
          height: 3rem;
          line-height: 3rem;
          border-radius: 10rem;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          background-color: #f2f2f2;
          font-size: 1.2rem;
          color: #555;
          margin-right: 1.8rem;
          margin-bottom: 1.5rem;
          cursor:pointer;
          &:nth-child(2n) {
            margin-right: 0;
          }
          &.active {
            background-color: var(--theme);
            color: #fff;
          }
        }
      }
    }

    .price {
        padding: 1.3rem 2rem 1.5rem;
        width: 100%;
        .title {
          font-size: 1.4rem;
          color: #555;
          margin-bottom: 1rem;
          text-align: left;
        }
        .rang {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 1rem;
          .van-field {
            width: 14rem;
            height: 3.2rem;
            line-height: 3.2rem;
            background-color: #efefef;
            border-radius: 10rem;
            padding: 0;
            text-align: center;
            border: 1px solid transparent;
            /deep/input {
              text-align: center;
              font-size: 1.4rem;
              color: #555;
            }
          }
          .line {
            width: 3.3rem;
            height: .2rem;
            background-color: #dbdbdb;
          }
          &.active {
            .van-field {
              border-color: var(--theme);
            }
          }
        }
        .choose_rang {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-wrap: wrap;
          margin-bottom: 1rem;
          .rang_item{
            width: 10.4rem;
            height: 3.2rem;
            line-height: 3.2rem;
            text-align: center;
            background-color: #efefef;
            border-radius: 10rem;
            font-size: 1.4rem;
            margin: 0 1rem 1rem 0;
            &.active {
              background-color: var(--theme);
              color: #fff;
            }
            &:nth-child(3n) {
              margin-right: 0;
            }
          }
        }
        .btns {
          display: flex;
          justify-content: space-around;
          .btn {
            width: 15.6rem;
            height: 4rem;
            border-radius: 10rem;
            background-color: #efefef;
            color: #555;
            font-size: 1.4rem;
            &.confirm {
              background-color: var(--theme);
              color: #fff;
            }
          }
        }
      }
  }
  .bg1 {
    position: fixed;
    top: 0;
    left: 50%;
    width: 100%;
    max-width: 525px;
    height: 100%;
    transform: translateX(-50%);
    background-color: rgba(0,0,0,0.4);
    z-index: 101;
  }

  .search_left_icon {
    width: 1.8rem;
    height: 1.8rem;
  }

  .inner_top {
    .title {
      width: 100%;
      position: relative;
    }
  }
</style>
